import { Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { ApplicationRequirements } from 'ng2-app/modules/borrower/models/application-requirements/application-requirements.interface';
import { StateService } from 'ng2-app/modules/shared/services/state.service';
import { ApiHttpClient } from 'app/http/clients/api';

@Injectable()
export class ApplicationRequirementsStore {

    constructor(
        private state: StateService,
        private http: ApiHttpClient
    ) { }

    forBorrower(borrowerId: number): Observable<ApplicationRequirements> {
        return this.state.select<ApplicationRequirements>(`borrower/${borrowerId}/application-requirements`);
    }

    forBorrowerPPP(borrowerId: number): Observable<ApplicationRequirements> {
        return this.state.select<ApplicationRequirements>(`borrower/${borrowerId}/ppp-application-requirements`);
    }

    toggleIssueIgnored(borrowerId: number, requirementId: number, ignore: boolean): any {
        if (ignore) {
            return this.http.post(
                `/borrower/${borrowerId}/application-requirements/ignore`,
                { appFieldRequirementId: requirementId })
                .pipe(
                    catchError(() => {
                        return of();
                    })
                );
        } else {
            return this.http.post(
                `/borrower/${borrowerId}/application-requirements/unignore`,
                { appFieldRequirementId: requirementId })
                .pipe(
                    catchError(() => {
                        return of();
                    })
                );
        }
    }
}
